import { forwardRef, memo } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = (_ref, ref) => {
  let {
    title,
    titleId,
    desc,
    descId,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    width: "1em",
    height: "1em",
    className: "interstate-pencil-square-icon",
    ref: ref,
    "aria-labelledby": titleId,
    "aria-describedby": descId,
    ...props,
    children: [desc ? /*#__PURE__*/_jsx("desc", {
      id: descId,
      children: desc
    }) : null, title ? /*#__PURE__*/_jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/_jsx("path", {
      d: "M14.345 1.655a.815.815 0 00-1.152 0l-.854.854 1.152 1.152.854-.854a.815.815 0 000-1.152zm-1.738 2.89l-1.152-1.152-6.417 6.416a2.83 2.83 0 00-.71 1.194l-.285.954.954-.284a2.83 2.83 0 001.194-.711l6.416-6.417zM12.31.771a2.065 2.065 0 112.92 2.92l-8.154 8.155c-.48.479-1.071.831-1.72 1.025l-2.063.614a.625.625 0 01-.777-.777l.614-2.062a4.08 4.08 0 011.025-1.72L12.31.77zM2.538 4.296c-.61 0-1.103.494-1.103 1.103v8.063c0 .609.494 1.103 1.103 1.103h8.063c.61 0 1.103-.494 1.103-1.103V9.814a.625.625 0 011.25 0v3.648c0 1.3-1.054 2.353-2.353 2.353H2.538a2.353 2.353 0 01-2.353-2.353V5.399c0-1.3 1.054-2.353 2.353-2.353h3.648a.625.625 0 110 1.25H2.538z"
    })]
  });
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
const Memo = /*#__PURE__*/memo(ForwardRef);

// eslint-disable-next-line react/no-multi-comp
export const PencilSquareIcon = /*#__PURE__*/forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx(Memo, {
    ...props,
    ref: ref
  });
});
PencilSquareIcon.displayName = 'PencilSquareIcon';